__turbopack_context__.v({
  "arrow": "-pMKnG_arrow",
  "container": "-pMKnG_container",
  "item": "-pMKnG_item",
  "list": "-pMKnG_list",
  "wrapper": "-pMKnG_wrapper",
});
